import HighlightIcon from '@/components2/HighlightIcon';
import React, { Fragment } from 'react';

export default function WithoutShuttles({
  highlights,
  facility,
  size = null,
  ...props
}) {
  const checkedHighlights = highlights.filter((highlight) => highlight.check);
  return (
    <>
      <div
        className={`grid grid-cols-2 gap-x-2 gap-y-4 self-center items-start`}
        {...props}
      >
        {checkedHighlights.map((highlight, index) => (
          <Fragment key={highlight.type + index}>
            {highlight.type === 'facility_distance' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="distance"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Distance
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {highlight.type === 'facility_free_cancellation' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="free-cancellations"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Free Cancellations
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {highlight.type === 'facility_accessibility' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="accessible"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Wheelchair Accessible
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {highlight.type === 'facility_open_hour' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="open_hour"
                  width={33}
                  height={33}
                  stroke="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Facility Access
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {highlight.type === 'facility_eletric_car' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="eletric_car"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    EV Charger
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}

            {highlight.type === 'facility_additional_comments' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="additional_comments"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Note
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {/* {highlight.type === 'facility_extra_free_cancellation' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="extra_fee_cancellation"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">Extra Fee Cancellation
                  
                   {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                
                </p>
              </div>
            )} */}
          </Fragment>
        ))}
      </div>
    </>
  );
}
